import React from "react";
import searchIcon from "../../../resources/search-icon.svg";
import "./Search.css";

function Search() {
  return (
    <div className="search">
      <input type="text" placeholder={"Search from the list of 1900+ Blogs"} />
      <img src={searchIcon} />
    </div>
  );
}

export default Search;
